import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
} from '@shared/components/ui/navigation-menu';
import { cn } from '@shared/lib/utils';
import { NavLink, useLocation } from 'react-router-dom';
import { SubTab } from './page-tabs';

export interface PageSubTabs {
  tabs: SubTab[];
}

export function PageSubTabs({ tabs }: PageSubTabs) {
  const location = useLocation();

  return (
    <NavigationMenu className="z-0 w-full max-w-none justify-start overflow-y-auto bg-teal-100">
      <NavigationMenuList className="w-full space-x-0 bg-teal-100">
        {tabs
          .filter((tab) => !tab.hide)
          .map((tab) => (
            <NavigationMenuItem key={tab.title} className="w-full bg-teal-100">
              <NavLink
                to={tab.href}
                onClick={(e) => tab.disabled && e.preventDefault()}
                className={({ isActive }) => {
                  const active =
                    isActive || location.pathname.includes(tab.href);
                  return cn(
                    'text-nowrap border-b-2 font-medium text-xs px-4 py-2.5 transition-all ease-in duration-150 flex flex-row items-center',
                    {
                      ' text-teal-950 border-b-2 border-b-teal-600': active,
                      ' hover:text-teal-900 hover:border-b-teal-300': !active,
                      'hover: cursor-default hover:text-gray-300 hover:border-b-none text-gray-300 ':
                        tab.disabled,
                    }
                  );
                }}
                end
              >
                {tab.title}
                {tab.icon && (
                  <div className="ml-1.5 flex h-[20px] items-center">
                    {tab.icon}
                  </div>
                )}
              </NavLink>
            </NavigationMenuItem>
          ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
